export default "__VITE_ASSET__D_Xdwql6__"